import { useEffect, useState } from "react";

export function useDebouncedValue(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

export function formatDate(value) {
  if (!value) return "*";

  const parts = String(value).split("-");
  if (parts.length !== 3) return "*";

  const [year, month, day] = parts;
  if (!year || !month || !day) return "*";

  return `${day}/${month}/${year}`;
}